import { render, staticRenderFns } from "./BlwPhone.vue?vue&type=template&id=12e277a4&"
import script from "./BlwPhone.vue?vue&type=script&lang=js&"
export * from "./BlwPhone.vue?vue&type=script&lang=js&"
import style0 from "./BlwPhone.vue?vue&type=style&index=0&id=12e277a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports